import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { PageDisplay, Pages, SubPageDisplay, SubPages } from "../../../../store/AppDisplays";
import { UserInfo, UserRoles } from "../../../../store/AppTypes";
import * as InvoiceTypes from "../../../../store/CollectiveInvoice/Types";
import { ReduxState, isRemoteLoading } from "../../../../store/ReduxState";
import { RemoteScope } from "../../../../store/RemoteTypes";
import { CreditDebitIndicator } from "../../../../store/Statements/Types";
import { ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { Header } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Header";
import { Page } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Page";
import { Filter } from "./Filter";
import { Results } from "./Results";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { Icon, IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: InvoiceTypes.CollectiveInvoices;
    user?: UserInfo;
}
type Props = StateProps;
/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.COLLECTIVE_INVOICE_RESULTS),
    results:
            s.prop("remote").prop(RemoteScope.COLLECTIVE_INVOICE_RESULTS),
    user: s.prop("user").isPresent() ? s.prop("user").get() : undefined,
});
/**
 *
 * @param props
 */
export class CollectiveInvoicesComp
    extends React.Component<Props, {}> {
    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
        this.state = {};
    }
    public render() {
        return (
            <Page>
                <Container
                    theme={{
                        padding: {
                            "": { y: 3 },
                            "sm": { y: 4 },
                        },
                    }}
                >
                    <Div className="scl-b-row">
                        <Grid
                            size={{ xs: 12, md: 8 }}
                        >
                            <Header
                                title={PageDisplay[Pages.COLLECTIVEINVOICES].title}
                                description={PageDisplay[Pages.COLLECTIVEINVOICES].description}
                            />
                        </Grid>
                        {this.props.user?.userRole !== UserRoles.EW_DEBTOR &&
                        this.props.user?.userRole !== UserRoles.EW_ADMIN_READONLY &&
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <Div
                                    style={{ textAlign: "right" }}
                                >
                                        <NavLink to={SubPageDisplay[SubPages.COLLECTIVE_INVOICE_GENERATION].path}>
                                            <Button
                                                theme={{ palette: ThemePalette.BRAND_ACCENT }}
                                                className="scl-a-btn--big"
                                            >
                                                {SubPageDisplay[SubPages.COLLECTIVE_INVOICE_GENERATION].title}
                                        &nbsp;
                                        &nbsp;
                                                <Icon name={IconNames.ARROW_RIGHT} />
                                            </Button>
                                        </NavLink>
                                </Div>
                            </Grid>}
                    </Div>
                    <Div
                        theme={{
                            padding: {
                                "": { b: 3 },
                                "sm": { b: 4 },
                            },
                        }}
                    >
                        <Filter
                            loadingFilters={this.props.loadingFilters}
                            loadingResults={this.props.loadingResults}
                            currentPage={Pages.COLLECTIVEINVOICES}
                            defaultFilters={{ creditDebitIndicator: CreditDebitIndicator.DBIT }}
                        />
                        <Results
                            results={this.props.results}
                            loadingResults={this.props.loadingResults}
                            currentPage={Pages.COLLECTIVEINVOICES}
                            scope={RemoteScope.COLLECTIVE_INVOICE_RESULTS}
                        />
                    </Div>
                </Container>
            </Page>
        );
    }
}
/**
 *
 */
export const CollectiveInvoices = connect(
    mapStateToProps,
    {},
)(CollectiveInvoicesComp);
